import React from 'react'
import { TranslationProvider } from '../shared/TranslationProvider'
import translations from './locales.json'
import CoachChatButton from './CoachChatButton'
// import { useTranslation } from '~/hooks/useTranslation'

const CoachChat = (props) => {
  return (
    <TranslationProvider
      locale={props.current_user.locale}
      translations={translations}
      scope="javascript.components.coach_chat"
    >
      <CoachChatButton {...props} />
    </TranslationProvider>
  )
}

export default CoachChat
